/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2021
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './SensorGroups.module.css';
import Checkbox from '../../../../components/Checkbox';
import edit from '../../../../assets/images/Fireboard/edit.svg';
import backIcon from '../../../../assets/images/Fireboard/back2_red.png';
import strings from '../../../../globalization';

const SensorGroups = props => {
  const { sensorGroupsList, dismissPopup, openEditSensorGroupPopup } = props;

  const onEdit = sensor => {
    openEditSensorGroupPopup && openEditSensorGroupPopup(sensor);
  };

  const renderHeader = () => (
    <div className={styles.rowView}>
      <span className={[styles.idCol, styles.centerAlign].join(' ')}>{strings.idCaps}</span>
      <span className={[styles.nameCol, styles.centerAlign].join(' ')}>{strings.nameLabel}</span>
      <span className={[styles.orderingCol, styles.centerAlign].join(' ')}>{strings.orderingEnabled}</span>
      <span className={[styles.foodRunnerCol, styles.centerAlign].join(' ')}>{strings.foodRunnerDisabled}</span>
      <span className={[styles.editCol, styles.centerAlign].join(' ')}>{strings.editLabel}</span>
    </div>
  );

  const renderContent = () => {
    return (
      sensorGroupsList.map(sensor =>
        <div key={sensor.id} className={styles.rowView}>
          <span className={[styles.idCol, styles.valueTxt].join(' ')}>{sensor.id}</span>
          <span className={[styles.nameCol, styles.valueTxt].join(' ')}>{sensor.name}</span>
          <span className={[styles.orderingCol, styles.valueTxt].join(' ')}>
            <Checkbox checked={sensor.enableTableOrder} readOnly />
          </span>
          <span className={[styles.foodRunnerCol, styles.valueTxt].join(' ')}>
            <Checkbox checked={sensor.disableFoodRunner} readOnly />
          </span>
          <span className={[styles.editCol, styles.valueTxt].join(' ')}>
            <img src={edit} className={styles.editImg} alt='Edit' onClick={() => onEdit(sensor)} />
          </span>
        </div>
      )
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.backButton} onClick={dismissPopup}>
        <img src={backIcon} className={styles.backImg} alt="Back" />
      </div>
      <div className={styles.sensorWrapper}>
        {renderHeader()}
        <div className={styles.scrollableView}>
          {renderContent()}
        </div>
      </div>
    </div >
  );
};

export default SensorGroups;

SensorGroups.propTypes = {
  sensorGroupsList: PropTypes.array,
  dismissPopup: PropTypes.func,
  openEditSensorGroupPopup: PropTypes.func,
};

SensorGroups.defaultProps = {
  sensorGroupsList: [],
  dismissPopup: () => { },
  openEditSensorGroupPopup: () => { },
};
